<template>
<div>
    <div  class="vs-component vs-con-table vs-table-primary">
        <component :is="'VuePerfectScrollbar'" class="scroll-area-content" :settings="settings" :key="$vs.rtl">
            <div class="con-tablex vs-table--content">
                <div class="vs-con-tbody vs-table--tbody ">
                    <table class="w-full vs-table vs-table--tbody-table block"  >
<!--                        <thead class="vs-table&#45;&#45;thead">-->
                        <vs-table  :data="DATA">

                            <template slot="thead">
                                <th class="text-center border-class">№</th>
                                <vs-th class="border-class">
                                    {{$t('fio')}}
                                </vs-th>
                                <th class="text-center border-class ">
                                    {{ $t('evaluation') }}
                                </th>
                                <th class="border-class" v-if="AntiPlagiarismRequired">
                                    {{ $t('anti_plagiarism') }}
                                </th>

                            </template>

                            <template slot-scope="{data}">
                                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                                    <vs-td class="text-center border-class">
                                        {{ indextr+1 }}
                                    </vs-td>
                                    <vs-td :data="data[indextr].profile" class="border-class ">
                                        {{ data[indextr].profile }}
                                    </vs-td>
                                    <vs-td :data="data[indextr].mark" class="border-class text-center flex justify-center">
                                        <tippy color="primary" arrow class="lesson-student-tippy" style="width: fit-content" :delay="300" :duration="0" :zIndex="53001">
                                            <template slot="trigger">
                                                <a @click="openMarkModle(data[indextr])" class="cursor-pointer" v-if="data[indextr].missed">
                                                    {{ $t('missed') }}
                                                </a>
                                                <a @click="openMarkModle(data[indextr])" class="cursor-pointer" v-else>
                                                    {{ data[indextr].mark.weight==null?'-':data[indextr].mark.weight }}
                                                </a>
                                            </template>
                                            <div class="template_lesson">
                                                {{ data[indextr].full_name }}<br/>
                                                <template v-if="Object.keys(data[indextr].mark).length > 0">
                                                    {{$t('evaluation')}}: {{ data[indextr].mark.weight }}<br/>
                                                </template>
                                                <template v-else>
                                                    {{$t('no_grade')}}<br/>
                                                    <template v-if="data[indextr].missed">
                                                        {{$t('n')}} - {{$t('absent')}}<br/>
                                                    </template>
                                                    <template v-if="data[indextr].missed">
                                                        {{$t('cause')}}:

                                                        <template v-if="lessonDay.reason.length > 0">
                                                            {{ lessonDay.reason }}
                                                        </template>
                                                        <template v-else>{{$t('unknown')}}</template>

                                                    </template>
                                                </template>
                                            </div>
                                        </tippy>
                                    </vs-td>
                                    <vs-td :data="data[indextr].anti_plagiarism" class="border-class" v-if="AntiPlagiarismRequired">
                                        <a @click="moodleAll(
                                            data[indextr],
                                            data[indextr].anti_plagiarism,
                                            'anti_plagiarism',
                                            {key:'anti_plagiarism',anti_plagiarism:true},
                                            indextr
                                            )"
                                           class="cursor-pointer">
                                            {{ data[indextr].anti_plagiarism==null?'-':data[indextr].anti_plagiarism }}
                                        </a>
                                    </vs-td>
                                </vs-tr>
                            </template>

                        </vs-table>
<!--                        </thead>-->

                    </table>
                </div>
            </div>
            <div class="flex justify-end mt-2">
                <div>
                    <div v-if="(status.code=='NEW'||status.code=='REJECTED')&&($router.history.current.name != 'vedomosti-is-office-view') && roles['is_teacher']">
                        <div>
                            <vs-button @click="requestStatus('NEW',status)" :disabled="updateAccess()" class="m-1"   color="warning" type="border" size="small">
                                {{ $t('on_check') }}
                            </vs-button>
                        </div>
                    </div>
                    <div v-else-if="status.code=='ONINSPECTION'">
                        <div v-if="$router.history.current.name == 'vedomosti-is-office-view' && roles['is_office']">
                            <vs-button @click="requestStatus('REJECTED',status)" class="m-1"  color="danger" type="border" size="small">
                                {{ $t('reject') }}
                            </vs-button>
                            <vs-button @click="requestStatus('APPROVED',status)" class="m-1"  color="success" type="border" size="small">
                                {{ $t('button_approve') }}
                            </vs-button>
                        </div>
                    </div>
                </div>
            </div>
        </component>
    </div>
    <vs-prompt
        :buttons-hidden="true"
        :title="$t('comment_for_reject_period')"
        :active.sync="popupActive2"
    >
        <vs-textarea
            v-model="textarea"
            name="reject_textarea_modal"
            v-validate="'required|min:3|max:500'"
        />
        <span
            class="text-danger text-sm"
            v-show="errors.has('reject_textarea_modal')"
        >{{ errors.first("reject_textarea_modal") }}<br
        /></span>
        <vs-button
            color="primary"
            type="filled"
            @click="rejectAllAcademicPeriodsInRender()"
        >
            {{ $t("button_reject") }}
        </vs-button>
    </vs-prompt>
    <vs-popup class="holamundo" :title="modal_data.profile" :active.sync="popupActive3" >
        <span>
            {{ $t(type) }}
        </span><br>
        <input
            class="style-input mt-2"
            type="number"
            v-model="num_ber"
            v-on:keyup="
                    updateValue(
                        num_ber,
                    )"
        >
        <vs-button
            color="primary"
            icon="save"
            @click="requestData"
            class="mt-2"
            type="filled">
        </vs-button>

    </vs-popup>
    <vs-popup class="holamundo" :title="modal_data.profile" :active.sync="popupActive" >
        <div class="pt-2 pb-6">
            <vs-row class="px-1 ">
                <vs-col vs-w="12" class="mb-3" v-for="(item, index) in estimates_members_commission" :key="index">
                    <vs-row>
                        <vs-col vs-w="6" class="flex items-center" v-if="item.profile == null">
                            <h6>{{ index+1 }}. {{ item.profile_text }}</h6>
                        </vs-col>
                        <vs-col vs-w="6" class="flex items-center" v-else>
                            <h6>{{ index+1 }}. {{ item.profile.fullname }}</h6>
                        </vs-col>
                        <vs-col vs-w="6" class="flex items-center">
                            <multiselect
                                label="name"
                                v-model="mark[index]"
                                :max-height="120"
                                :options="optionsMark"
                                :disabled="modal_data.missed||!access"
                                :placeholder="$t('evaluation')"
                                name="mark"
                                deselectLabel=""
                                class="custom-multiselect"
                                :selectedLabel="$t('selected')"
                                @open="multiselectOpen(true)"
                                @input="multiselectAction(mark[index],item,index)"
                                @remove="multiselectAction(mark[index],item)"
                                track-by="uid">
                                <div slot="noOptions">{{$t('no_data_text')}}</div>
                            </multiselect>
                        </vs-col>
                    </vs-row>
                </vs-col>
                <vs-col>
                    <multiselect
                        label="name"
                        v-model="grading_system"
                        :options="[]"
                        :disabled="true"
                        :placeholder="$t('evaluation')"
                        name="mark"
                        deselectLabel=""
                        class="custom-multiselect mb-3"
                        :selectedLabel="$t('selected')"
                        track-by="uid">
                        <div slot="noOptions">{{$t('no_data_text')}}</div>
                    </multiselect>
                    <vs-textarea
                        v-if="modal_data.missed"
                        class="mb-3"
                        name="reason"
                        v-model="modal_data.reason"
                        :placeholder="$t('cause')"/>
                    <vs-button
                        v-show="button_save"
                        style="margin-top: -5px;"
                        @click="click_buttom_save"
                        color="primary"
                        icon="save"
                        class="mb-3"
                        type="filled">
                    </vs-button>
                    <vs-checkbox
                        v-model="modal_data.missed"
                        :disabled="!access"
                        class="mb-3 flex"
                        style="margin-left: 1.5px;margin-right: 0px;width: max-content;">
                        {{$t('skip')}}
                    </vs-checkbox>
                </vs-col>
            </vs-row>
        </div>
    </vs-popup>


</div>
</template>

<script>

import { payloadParams } from './utils'
import {mapActions, mapGetters,mapMutations} from "vuex";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import axios from '@/configs/Axios'
export default {
    components: {
        VuePerfectScrollbar
    },
    props: {
        is_practice:{
            type: Boolean,
            required: false
        },
        AntiPlagiarismRequired:{
            type: Boolean,
            required: false
        },
        status:{
            type:Object,
            required:true
        }
    },
    data() {
        return {
            settings: {
                maxScrollbarLength: 60,
                wheelSpeed: 0.50
            },
            popupActive:false,
            modal_data:{},
            optionsMark:[],
            number:34,
            focused:false,
            counter: 0,
            estimates_members_commission:[],
            mark:[],
            creted:false,
            grading_system:{},
            button_save:false,
            test:'',
            access:false,
            popupActive2: false,
            popupActive3: false,
            textarea: '',
            num_ber:null,
            data_data:{},
            type:null,
            key:null,
            index:null

        }
    },
    computed: {
        ...mapGetters({
            GET_MARK: 'vedomosti/GET_MARK',
            GET_VEDOMOST: 'vedomosti/GET_VEDOMOST',
            GET_ACCESS: 'vedomosti/GET_ACCESS',
        }),
        DATA(){
            return JSON.parse(JSON.stringify(this.GET_MARK))
        },
        roles(){
            return this.$store.state.user.roles
        },
        check_access(){
            return (this.GET_ACCESS)&&(this.$router.history.current.name != 'vedomosti-is-office-view')&&(this.status.code != 'ONINSPECTION')&&(this.status.code != 'APPROVED')
        },
        checkDATA() {
            const obj = this.DATA.find((item) => {
                return item.mark.weight != null
            })
            if(obj == undefined || obj == null) return false
            else return true
        }
    },
    async created() {
        if(!this.$store.hasModule('vedomosti'))
            this.$store.registerModule('vedomosti', vedomosti)
        if (this.$route.query.uid){
            this.MARK({uid:this.$route.query.uid,study_plan_uid_1c:this.$route.query.study_plan})
            this.ACCESS({uid:this.$route.query.uid,study_plan:this.$route.query.study_plan})
        }

    },
    watch:{
        async 'modal_data.missed'(){
            // console.log(this.modal_data)
            if (!this.creted){
                await this.$http.put(
                    '/schedules/vedomosti/missed/',
                    {
                        uid:this.modal_data.uid,
                        missed:this.modal_data.missed,
                        vedomosti:this.GET_VEDOMOST.uid,
                    }
                ).then(
                    (res)=>{
                        this.CHANGE_MISSED_PROGRESS_OF_STUDENTS(
                            {
                                missed:this.modal_data.missed,
                                data:this.modal_data.uid,
                                mark:res.data
                            }
                        )
                        this.$vs.notify({
                            title: this.$t('success_save'),
                            color: "success"
                        })
                    }
                )
            }
        },
        async 'modal_data.reason'(){
            if (!this.creted){
                this.button_save = true
            }
        },
        // async num_ber(){
        //     if (this.num_ber == ''||this.num_ber  == null){
        //         this.num_ber  = null
        //     }else{
        //         this.num_ber  = this.num_ber.slice(0, 3);
        //     }
        // }
    },
    methods: {
        async requestData(){
            this.$vs.loading()
            await this.$http.put(
                '/schedules/vedomosti/number/',
                {
                    type:this.type,
                    number:this.num_ber==null?null:Number(this.num_ber),
                    uid:this.data_data.uid
                }
            )
            this.$vs.notify({
                title: this.$t('success_save'),
                color: "success"
            })
            this.DATA[this.index][this.key.key] = this.num_ber==null?null:Number(this.num_ber)
            this.$vs.loading.close();
        },
        async moodleAll(val,number,type,key,indextr){
            if(this.check_access){
                this.key = key
                this.type = type
                this.num_ber = number
                this.data_data = JSON.parse(JSON.stringify(val))
                this.index = indextr
                this.modal_data.profile = JSON.parse(JSON.stringify(val)).profile
                this.popupActive3 = true
            }
        },
        ...mapMutations({
            CHANGE_MARK_PROGRESS_OF_STUDENTS: "vedomosti/CHANGE_MARK_PROGRESS_OF_STUDENTS",
            CHANGE_REASON_PROGRESS_OF_STUDENTS: "vedomosti/CHANGE_REASON_PROGRESS_OF_STUDENTS",
            CHANGE_MISSED_PROGRESS_OF_STUDENTS: "vedomosti/CHANGE_MISSED_PROGRESS_OF_STUDENTS",
            SLICE_NUMBER: "vedomosti/SLICE_NUMBER",
            CHANGE_VEDOMOSTI: "vedomosti/CHANGE_VEDOMOSTI",
        }),
        ...mapActions({
            MARK: 'vedomosti/MARK',
            ACCESS: 'vedomosti/ACCESS',
        }),
        async openMarkModle(val){
            if (this.check_access){
                this.creted = true
                this.$vs.loading()
                this.modal_data = JSON.parse(JSON.stringify(val))
                this.popupActive = true
                await this.$http.get(
                    '/schedules/vedomosti/estimates_members_commission/',{
                        params:{
                            'progress_of_students':val.uid,
                            'vedomosti':this.GET_VEDOMOST.uid,
                            'study_plan':this.$route.query.study_plan
                        }
                    }
                ).then((res)=>{
                    this.access = res.data.access
                    this.estimates_members_commission = res.data.data
                })
                this.mark = []
                this.estimates_members_commission.forEach((item)=>{
                    if (item.composition_sec_commissions.mark){
                        this.mark.push(item.composition_sec_commissions.mark)
                    }else{
                        this.mark.push(null)
                    }
                })
                this.grading_system = (
                    await this.$http.post(
                        '/schedules/vedomosti/system/separately/',
                        {
                            'control_form':this.GET_VEDOMOST.control_form.uid
                        }
                    )
                ).data
                this.$vs.loading.close()
                this.creted = false
            }
        },
        async multiselectOpen(){
            this.$vs.loading()
            this.optionsMark = (
                await this.$http.post(
                    '/schedules/vedomosti/system/',
                    {
                        'control_form':this.GET_VEDOMOST.control_form.uid,
                        'vedomosti':this.GET_VEDOMOST.uid,
                    }
                )
            ).data
            this.$vs.loading.close()
        },
        async saveMark(){
            await this.$http.put(
                '/schedules/vedomosti/change/mark/',
                this.modal_data
            )
        },
        async multiselectAction(val,item,index){
            this.$vs.loading()
            await this.$http.put(
                '/schedules/vedomosti/change/estimates_members_commission/', {
                    mark:val?val.uid:null,
                    composition_sec_commission:item.uid,
                    progress_of_students:this.modal_data.uid,
                }
            ).then(
                (res)=>{
                    this.CHANGE_MARK_PROGRESS_OF_STUDENTS(
                        {
                            mark:res.data,
                            data:this.modal_data.uid
                        }
                    )
                    this.$vs.notify({
                        title: this.$t('success_save'),
                        color: "success"
                    })
                }
            )
            this.popupActive = false
            this.$vs.loading.close()
        },
        async click_buttom_save(){
            this.$vs.loading()
            await this.$http.put(
                '/schedules/vedomosti/reason/',
                {
                    uid:this.modal_data.uid,
                    reason:this.modal_data.reason,
                }
            ).then(
                (res)=>{
                    this.$vs.notify({
                        title: this.$t('success_save'),
                        color: "success"
                    })
                    this.CHANGE_REASON_PROGRESS_OF_STUDENTS(
                        {
                            data:this.modal_data.uid,
                            reason:this.modal_data.reason,
                        }
                    )
                }
            )
            this.$vs.loading.close()
        },

        async updateValue(val,index,event,type,uid) {
            var clone_val = val
            if (clone_val == ''||clone_val == null){
                clone_val = null
            }else{
                clone_val = clone_val.slice(0, 3);
            }
            this.num_ber = clone_val
            // try {
            //     // this.$vs.loading()
            //     var clone_val = val
            //     if (clone_val == ''||clone_val == null){
            //         clone_val = null
            //     }else{
            //         clone_val = clone_val.slice(0, 3);
            //     }
            //     this.num_ber = clone_val
            // this.SLICE_NUMBER({'number':clone_val,'index':index,'event':event})
            // this.DATA[index][event.key] = clone_val
            // await this.$http.put(
            //     '/schedules/vedomosti/number/',
            //     {
            //         type:type,
            //         number:clone_val==null?null:Number(clone_val),
            //         uid:uid
            //     }
            // )
            // } catch(e) {
            //     this.$vs.notify({
            //         text: this.$t('error'),
            //         color: 'danger'
            //     })
            // } finally {
            // this.$vs.notify({
            //     title: this.$t('success_save'),
            //     color: "success"
            // })
            // this.$vs.loading.close()
            // }

        },
        requestApproved(status,uid){
            this.$validator.validateAll().then(async (result) => {
                this.request('APPROVED',uid)
            })
        },
        async request(status,uid){
            await axios.post('schedules/vedomosti/status_change/',{uid:uid,status:status})
                .then((res)=>{
                    this.changeStatusVedomosti(res.data)
                    if (status == 'APPROVED'){
                        this.$vs.notify({
                            text: this.$t("the_statement_is_approved"),
                            color: "success",
                        });
                    }else {
                        this.$vs.notify({
                            text: this.$t('data_saved'),
                            color: 'success'
                        })
                    }
                })
                .catch((error)=>{
                    this.$vs.notify({
                        text: this.$t(error.error),
                        color: "danger",
                    });
                })
        },
        async requestStatus(name,val){
            try {
                if(this.DATA.length > 0 && this.checkDATA == true) {
                    this.$vs.loading()
                    var query = this.$route.query
                    if (name == 'NEW'){
                        var status = await 'ONINSPECTION'
                    } else if (name == 'ONINSPECTION') {
                        var status = await 'NEW'
                    }else if (name == 'REJECTED'){
                        this.popupActive2 = await true
                    }else if (name == 'APPROVED'){
                        await this.requestApproved('APPROVED',query.uid)
                    }
                    if (name != 'REJECTED'&&name != 'APPROVED'){
                        await this.request(status,query.uid)
                    }
                } else {
                    this.$vs.notify({
                        text: this.$t('the_statement_not_filled'),
                        color: 'danger'
                    })
                }
            } catch(e) {
                this.$vs.notify({
                    text: this.$t('error'),
                    color: 'danger'
                })
            } finally {
                this.$vs.loading.close()
            }

        },
        rejectAllAcademicPeriodsInRender() {
            this.$validator.validateAll().then(async (result) => {
                if (result) {
                    try {
                        this.$vs.loading();
                        var query = this.$route.query
                        var status = 'REJECTED'
                        await axios.post('schedules/vedomosti/status_change/',{uid:query.uid,status:status,comment:this.textarea}).then((res)=>{
                            this.changeStatusVedomosti(res.data)
                            this.$vs.notify({
                                text: this.$t("the_statement_was_rejected"),
                                color: "danger",
                            });
                        })
                    } catch (e) {
                    } finally {
                        this.popupActive2 =false
                        this.$vs.loading.close();
                    }
                } else {
                    // Вывести "заполни все поля"
                    this.$vs.notify({
                        title: this.$t("warning"),
                        text: this.$t("Fillallfields"),
                        color: "danger",
                    });
                }
            });
        },
        changeStatusVedomosti(val){
            this.CHANGE_VEDOMOSTI(val)
        },
        // Обновляю access
        updateAccess() {
            this.access = this.GET_ACCESS
            if(!this.access && this.roles['is_teacher']) return true
        },
    }
}
</script>

<style lang="scss" scoped>
    .style-input{
        border: 1px solid #e5e5e5;border-radius:4px;width: max-content;
    }
    .vs-popup{
        width: 100% ​!important;
    }

.journal_loader{
    .scroll-area-content{
        height: calc(var(--vh, 1vh)*100 - 30rem);
    }
}

@media only screen and (max-width: 900px) {
    .journal_loader{
        .scroll-area-content{
            height: calc(var(--vh, 1vh)*100 - 30rem);
        }
    }
}

.vs-table--content{
    overflow: initial !important;
}
.vs-con-table{
    .vs-con-tbody{
        overflow: initial !important;
    }
}
</style>


<style lang="scss">
input[type="number"] {
    display: inline-block;
    height: 26px;
    line-height: 26px;
    width: 100%;
    text-indent: 6px;
    -moz-appearance: textfield;
    -webkit-appearance: textfield;
    appearance: textfield;
}
input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
    display: none;
}
.v-tour {
  .v-step {
    z-index: 55000;
    background-color: rgba(var(--vs-primary), 1);
    border-radius: 0.5rem;
    padding: 1.5rem;
    filter: drop-shadow(0 0 7px rgba(0, 0, 0, 0.5));

    .v-step__arrow {
      border-color: rgba(var(--vs-primary), 1);
    }

    .vs-button-border:not(.btn-tour-next):not(.btn-tour-finish) {
      border-color: rgba(255, 255, 255, 0.5) !important;
    }
  }
}
</style>


<style lang="scss">
.vs-popup{
    height: auto !important;
}
.vs-table--tbody-table {
    .tr-values{
        td{
            padding: 0px;
        }

        .vs-button:not(.vs-radius):not(.includeIconOnly):not(.small):not(.large){
            padding: 10px 0px;
        }


    }
}


.cntrl_date_loader,
.control_loader,
.journal_loader{
    position: relative;
    .con-vs-loading{
        position: absolute;
    }
}
.border-class{
    border: 2px solid #f8f8f8 !important;
}
.tippy-tooltip{
    background-color: #545da7;
}
</style>
